import {
  Component,
  Input,
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';
import { CustomSelectOption } from 'src/app/core/interfaces/custom-select-option';
import { PhysicalExamCategory } from 'src/app/core/models/physical-exam-category';
import { PhysicalExamCategoryService } from 'src/app/core/services/general/physical-exam-category.service';

@Component({
  selector: 'app-physical-exam-category-input',
  templateUrl: './physical-exam-category-input.component.html',
  styleUrls: ['./physical-exam-category-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: PhysicalExamInputCategoryComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: PhysicalExamInputCategoryComponent,
    },
  ],
})
export class PhysicalExamInputCategoryComponent {
  @Input()
  title = "Select Physical Exam Category...";

  @Input()
  isDisabled = false;

  public value?: string;
  public localValue?: CustomSelectOption;

  public physicalExamCategoriesList: Array<CustomSelectOption> = [];

  constructor(
    private physicalExamCategoryService: PhysicalExamCategoryService,
  ) {
    this.physicalExamCategoryService
      .all()
      .subscribe((res: Array<PhysicalExamCategory>) => {
        this.physicalExamCategoriesList = res.map((el) => {
          return {
            name: `${el.name}`,
            value: el.uuid,
          }
        });
        this.writeValue(this.value);
      });
  }

  ngOnInit(): void {
  }

  onChange = (val: string | undefined) => {
  };

  onTouched = () => { };

  touched = false;
  disabled = false;

  writeValue(val?: string) {
    this.value = val;
    if (this.value != undefined || this.value != null) {
      this.localValue = this.physicalExamCategoriesList.filter((el) => el.value == val)[0];
    }
  }

  onValueChange(val?: CustomSelectOption) {
    this.value = val?.value;
    this.onChange(this.value);
    this.writeValue(this.value);
  }


  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }
}
